import customerApiFactory from '../../modules/customer/customerApi';

/* Utils */
import {
  generateDefaultAsyncWatcher,
  generateDefaultAsyncSaga,
} from '../core/reduxUtils';

/* Actions */
import {
  getCustomerInfoActionCreators
} from '../actions/customerActions';

function customerSagasFactory({storefrontApiClient}) {
  const customerApi = customerApiFactory(storefrontApiClient);

  const getCustomerInfo = generateDefaultAsyncSaga(
    customerApi.getCustomerInfo,
    getCustomerInfoActionCreators,
    payload => [
      payload.params,
    ]
  );

  const watchGetCustomerInfo = generateDefaultAsyncWatcher(
    'GET_CUSTOMER_INFO',
    getCustomerInfo
  );

  const customerSagas = [
    watchGetCustomerInfo(),
  ];

  return customerSagas;
}

export default customerSagasFactory;
